<div class="flex flex-col grow h-full">
    <div class="w-full items-center h-[64px] border-b border-slate-300">
        <ng-content select="#header">
        </ng-content>
    </div>
    <div class="flex flex-row grow h-full">
        <div class="w-[64px] bg-gray-100 border-r border-slate-300">
            <ng-content select="#menu"></ng-content>
        </div>
        <div class="h-full grow">
            <ng-content></ng-content>
        </div>
    </div>
</div>